import 'slick-carousel';

const initHorizontalSlider = () => {
  jQuery('.js-horizontal-slider').not('.slick-initialized').slick({
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    asNavFor: '.js-horizontal-slider-nav',
  });

  jQuery('.js-horizontal-slider-no-dots').not('.slick-initialized').slick({
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    asNavFor: '.js-horizontal-slider-nav',
  });

  jQuery('.js-horizontal-slider-nav').not('.slick-initialized').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-horizontal-slider',
    arrows: true,
    prevArrow: '<button class="slick-prev"><span class="icon-long-arrow-l"></span></button>',
    nextArrow: '<button class="slick-next"><span class="icon-long-arrow-r"></span></button>',
  });

  jQuery('.js-buybycats-slider').not('.slick-initialized').slick({
    slidesToShow: 4,
    adaptiveHeight: false,
    prevArrow: '<button class="slick-prev"><span class="icon-long-arrow-l"></span></button>',
    nextArrow: '<button class="slick-next"><span class="icon-long-arrow-r"></span></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          rows: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 1
        }
      }
    ],
  });

  jQuery('.js-product-slider').not('.slick-initialized').slick({
    slidesToShow: 4,
    adaptiveHeight: false,
    prevArrow: '<button class="slick-prev"><span class="icon-long-arrow-l"></span></button>',
    nextArrow: '<button class="slick-next"><span class="icon-long-arrow-r"></span></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          rows: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 1
        }
      }
    ],
  });

  jQuery('.js-brands-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    adaptiveHeight: false,
    mobileFirst: true,
    dots: false,
    prevArrow: '<button class="slick-prev"><span class="icon-long-arrow-l"></span></button>',
    nextArrow: '<button class="slick-next"><span class="icon-long-arrow-r"></span></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 1
        }
      }
    ],
  });

  jQuery('.js-service-slider').not('.slick-initialized').slick({
    slidesToShow: 3,
    adaptiveHeight: false,
    arrows: true,
    dots: false,
    prevArrow: '<button class="slick-prev"><span class="icon-long-arrow-l"></span></button>',
    nextArrow: '<button class="slick-next"><span class="icon-long-arrow-r"></span></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          rows: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 1
        }
      }
    ],
  });

  jQuery('.js-news-slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    mobileFirst: true,
    adaptiveHeight: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1439,
        settings: {
          slidesToShow: 5,
          rows: 1
        }
      },
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 4,
          rows: 1
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          rows: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 1
        }
      }
    ],
  });
};

export default initHorizontalSlider;
